import { render } from "./Visitantes.vue?vue&type=template&id=f52c3184"
import script from "./Visitantes.vue?vue&type=script&lang=js"
export * from "./Visitantes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__